exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".report-form .ant-breadcrumb > span:last-child {\n  cursor: default;\n  pointer-events: none; }\n\n.report-form div.antd-cancel-button {\n  padding-top: 20px; }\n  .report-form div.antd-cancel-button .antd-cancel-button {\n    width: 150px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/ReportForm/components/ReportForm/style.scss
// module id = 1008
// module chunks = 0